<script setup>
import CookieConsentBanner from '@/components/CookieConsentBanner.vue';

const userStore = useUserStore();

window.addEventListener('beforeinstallprompt', (e) => {
  console.log('beforeinstallprompt event fired');
  e.preventDefault();

  userStore.pwaInstallEvent = e
});

</script>

<template>
  <NuxtPwaManifest />
  <slot />
  <div class="fixedClass">
    <CookieConsentBanner />
  </div>

</template>
<style scoped>
.fixedClass{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
